import React from 'react';
import { Table, Form  } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import Select from 'react-select';
import { postRequestOptions, getRequestOptions} from "../helpers/Fetchwrapper";
import { Card } from 'react-bootstrap-v5';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { numberFormat, unitNameByProject } from '../helpers/GlobalHelper';
import { useLocation, Link } from "react-router-dom";

// Define a type for the sales data
interface SalesData {
    idAccLedgers: number;
    idCompanies: number;
    companyName: string;
    name: string;
    opBalance: number;
    totalSales: number;
    totalShipmentAmount: number;
    totalInvoicedAmount: number;
    totalPaymentAmount: number;
    totalBalance: number;
    totalInvoiceQuantity: number;  
};

interface DueReportProps {

}

const SalesAdvanceReceiveReport: React.FC<DueReportProps> = (props) => {

    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const [loading, setLoading] = useState(false);
    const [salesData, setSalesData] = useState<SalesData[]>([]);
    const [formData, setFormData] = useState({
        idProjects: query.get('idProjects') ?? '',
        idSrCategories: query.get('idSrCategories') ?? '',
        fromDate: query.get('fromDate') ?? '',
        toDate: query.get('toDate') ?? '',
    })

    const [projects, setProjects] = useState([]);
	const [project, setProject] = useState({ label: 'Select Project', value: '' });

    const [categories, setCategories] = useState([])
    const [category, setCategory] = useState({ label: 'Select SR Category', value: '' });

    useEffect(() => {
        getProjects();
    }, [])

    useEffect(() => {

        if(projects.length>0){
            const projectObj = Number(query.get('idProjects')) ? projects.find((project: any) => project.value === Number(query.get('idProjects'))) : projects[0];
            setProject({
                label: projectObj?.label,
                value: projectObj?.value
            });
            
            setFormData({
                ...formData,
                idProjects: projectObj ? projectObj.value : '',
            });

            getCategories(projectObj?.value)

        }else{
            setProject({ label: 'Select Project', value: '' });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projects]);

    useEffect(() => {
        if (formData.idProjects && formData.fromDate && formData.toDate) {
            handleViewReport();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    const getProjects = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'lead/projects',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				let projectObj = resp.data.map((item: any) => {
					item.label = item.name;
					item.value = item.id;
					return item
				})
				setProjects(projectObj);
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

    const handleProjectChange = (project: any) => {
		setProject(project);
        if(project){
            setFormData({ ...formData, idProjects: project.value });
        }else{
		    setFormData({ ...formData, idProjects: '' });
        }

        getCategories(project.value)
	}

    const getCategories = async (idProjects: number) => {
    
        const url = process.env.REACT_APP_API_URL + 'allSrCategory?idProjects=' + idProjects
        const response = await fetch(url, getRequestOptions())
        const data = await response.json()

        data.map((element: any) => {
            element.value = element.id_sr_categories;
            element.label = element.sr_category_name;
            return element;
        })

        var allCategoriesOpt = [{ id: '', name: '', label: 'All', value: '' }]
        let allCategories = data.concat(allCategoriesOpt);
        setCategories(allCategories);

    }

    const handleCategoryChange = (category: any) => {
		setCategory(category);
        if(category){
            setFormData({ ...formData, idSrCategories: category.value });
        }else{
            setFormData({ ...formData, idSrCategories: '' });
        }
	}

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleViewReport = async () => {
        setLoading(true);

        try {
            const response = await fetch(process.env.REACT_APP_API_URL + 'reports/sales-advance-receive', postRequestOptions(formData));
            const data = await response.json();
            if (data.success) {
                setSalesData(data.data);
            } else {
                setSalesData([]);
                data.errors.forEach((error: string) => toast.error(error, { position: 'bottom-right', autoClose: 4000 }));
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Outside your component's return statement, initialize a serial number counter
    const queryParams = new URLSearchParams(formData);

    return (
        <>
            <Card className='mb-4'>
                <Card.Body>
                    <Card.Title></Card.Title>
                    <Card.Text>
                        <div className='row'>
                            <div className='col-md-3'>
                                <Form.Group className="mb-3" controlId="project">
                                    <Form.Label>Project<span className='required'></span></Form.Label>
                                    <Select
                                        value={project}
                                        onChange={handleProjectChange}
                                        options={projects}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        isClearable={true}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="project">
                                    <Form.Label>Select SR Category</Form.Label>
                                    <Select
                                        // defaultValue={selectProjectOptions}
                                        onChange={handleCategoryChange}
                                        options={categories}
                                        placeholder={category.label}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="project">
                                    <Form.Label>From Date<span className='required'></span></Form.Label>
                                    <Form.Control type="date" placeholder="From Date" name='fromDate' value={formData.fromDate} onChange={handleChange}/>
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="project">
                                    <Form.Label>To Date<span className='required'></span></Form.Label>
                                    <Form.Control type="date" placeholder="To Date" name='toDate' value={formData.toDate} onChange={handleChange}/>
                                </Form.Group>
                            </div>
                            <div className='col-md-1'>
                                <div className="form-control-sm ps-0 mt-7">
                                    <button className='btn btn-sm btn-primary w-100 p-3' onClick={handleViewReport} disabled={loading}>
                                        {loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        )}
                                        <span>View Report</span>
                                    </button>
                                </div>                                
                            </div>
                            <div className='col-md-1'>
                                <div className="form-control-sm ps-0 mt-7">
                                    <a className="btn btn-sm btn-primary w-100 p-3 mb-2" href={`${process.env.REACT_APP_BACKEND}sales_advance_receive_report_download?` + queryParams.toString()}><i className='fas fa-download'></i> Download</a>
                                </div>                                
                            </div>
                        </div>
                    </Card.Text>
                </Card.Body>
            </Card>
           
            <div className='row'>
                <div className='col-12'>
                    <Table responsive bordered hover>
                        <thead>
                            <tr>
                                <th className='text-center'>Sl.</th>
                                <th className='text-center'>Client Name</th>
                                <th className='text-center'>Sales Person</th>
                                <th className='text-center'>Shipment Made</th>
                                <th className='text-center'>Op. Balance</th>
                                <th className='text-center'>Total Dr</th>
                                <th className='text-center'>Total Cr</th>
                                <th className='text-center'>Balance</th>
                                <th className='text-center'>Qty( {unitNameByProject(project?.value)} )</th>
                            </tr>
                        </thead>
                        <tbody>

                            {salesData.length>0 ? salesData.map((company, slNo) => (
                               
                                <tr key={company.idCompanies}>
                                    <td className='text-center'>{slNo +1}</td>
                                    <td>
                                        <Link to={`reports?type=ledgerStatement&idProjects=${formData?.idProjects}&idAccLedgers=${company.idAccLedgers}&fromDate=${formData?.fromDate}&toDate=${formData?.toDate}`} target='_blank'>
                                            {company.companyName}
                                        </Link>
                                    </td>
                                    <td>{company.name}</td>
                                    <td className='text-end'>{numberFormat(company.totalShipmentAmount)}</td>
                                    <td className='text-end'>{numberFormat(company.opBalance)}</td>
                                    <td className='text-end'>{numberFormat(company.totalInvoicedAmount)}</td>
                                    <td className='text-end'>{numberFormat(company.totalPaymentAmount)}</td>
                                    <td className='text-end'>{numberFormat(company.totalBalance)}</td>
                                    <td className='text-end'>{numberFormat(company.totalInvoiceQuantity)}</td>
                                </tr>
                               
                            )) : (
                                <tr>
                                    <td colSpan={8} className='text-center'>No Data Found</td>
                                </tr>
                            )}
                        </tbody>
                        {salesData.length>0 ? (
                            <tfoot>
                                <tr>
                                    <td colSpan={3} className='text-end'><strong>Total</strong></td>
                                    <td className='text-end'><strong>{numberFormat(salesData.reduce((a, b) => a + Number(b.totalShipmentAmount), 0))}</strong></td>
                                    <td className='text-end'><strong>{numberFormat(salesData.reduce((a, b) => a + Number(b.opBalance), 0))}</strong></td>
                                    <td className='text-end'><strong>{numberFormat(salesData.reduce((a, b) => a + Number(b.totalInvoicedAmount), 0))}</strong></td>
                                    <td className='text-end'><strong>{numberFormat(salesData.reduce((a, b) => a + Number(b.totalPaymentAmount), 0))}</strong></td>
                                    <td className='text-end'><strong>{numberFormat(salesData.reduce((a, b) => a + Number(b.totalBalance), 0))}</strong></td>
                                    <td className='text-end'><strong>{numberFormat(salesData.reduce((a, b) => a + Number(b.totalInvoiceQuantity), 0))}</strong></td>
                                </tr>
                            </tfoot>
                        ) : null}
                    </Table>
                </div>
            </div>
        </>
    );
};

export default SalesAdvanceReceiveReport;